import type { FunctionComponent, ImgHTMLAttributes, ReactElement } from 'react';

import lobbyFallback from './lobbyFallback.svg';

export const LobbyFallback: FunctionComponent<ImgHTMLAttributes<HTMLImageElement>> = (props): ReactElement => (
  <img src={lobbyFallback} {...props} alt="Fallback" />
);
